import React from 'react';
import LeftSide from './hrana/LeftSide';
import MidSide from './hrana/MidSide';
import RightSide from './hrana/RightSide';

function Menu() {

    return (
        <>
            <MidSide />
            <LeftSide />
            <RightSide />

        </>
    )
}

export default Menu;